import { BlueArrowIcon } from '@/features/shared/Icons';
import { MuiTypography } from '@/features/shared/material-ui';
import clsx from 'clsx';
import React from 'react';
import { NavigationButtonProps } from '../../../PortalNavigation.interfaces';
import useNavigationButtonStyles from './NavigationButton.styles';

const NavigationButton = ({
  id,
  children,
  isOpened,
  onClick,
  ...restProps
}: React.PropsWithChildren<NavigationButtonProps>) => {
  const classes = useNavigationButtonStyles();
  return (
    <button
      type="button"
      id={id}
      className={clsx('portal-navigation-button', classes.navigationButton)}
      onClick={onClick}
      {...restProps}
    >
      <span className="button-content-wrapper">
        <MuiTypography className={classes.buttonLabel} component="span">
          {children}
        </MuiTypography>
        <BlueArrowIcon style={{ transition: 'all .3s' }} direction={isOpened ? 'top' : 'bottom'} />
      </span>
    </button>
  );
};

export default NavigationButton;
